import React, {useEffect, useState} from 'react';
import Popup from "./popup";
import axios from 'axios';
import {getHttpErrorMessage} from "../../_helpers";
import NumberFormat from "react-number-format";
import BackupAccountTermsPopup from "./backupAccountTermsPopup";
export default function ManualBankAccountPopup({successHandler,closeHandler,authToken, organization, user, accountType = ''})
{
	const [accountRoutingNumber,setAccountRoutingNumber] = useState('');
	const [accountNumber,setAccountNumber] = useState('');
	const [accountNumberConfirmation,setAccountNumberConfirmation] = useState('');
	const [isLoading,setIsLoading] = useState(false);
	const [errorFields,setErrorFields] = useState([]);
	const [message,setMessage] = useState('');
	const [accountName,setAccountName] = useState('');
	const [selectedAccountType,setSelectedAccountType] = useState('');
	const [bank,setBank] = useState('')
	const [agreed,setAgreed] = useState(false)
	const [showTermsPopup,setShowTermsPopup] = useState(false);


	const hasErrors = () =>{
		let errors = [];

		if(accountType === 'backup' && !agreed){
			errors.push('terms');
			setMessage('Must agree to account terms.')
		}

		if(accountName.trim().length<=0){
			errors.push('accountName');
			setMessage('Account Name required.');
		}
		if(accountRoutingNumber.trim().length<=0){
			errors.push('accountRoutingNumber');
			setMessage('Account Routing Number required.');
		}
		if(bank.trim().length<=0){
			errors.push('bank');
			setMessage('Institution Name required.');
		}

		if(accountNumberConfirmation !== accountNumber){
			errors.push('accountNumberConfirmation');
			setMessage('Account Numbers Must Match.');
		}
		if(accountNumberConfirmation.trim().length<=0){
			errors.push('accountNumberConfirmation');
			setMessage('Confirm Account Number.');
		}
		if(accountNumber.trim().length<=0){
			errors.push('accountNumber');
			setMessage('Account Number Required.');
		}

		setErrorFields(errors);
		return errors.length>0;
	};

	const saveHandler = () =>{
		if(isLoading || hasErrors()){
			return;
		}
		setIsLoading(true);
		let newAccountType = 'emergency';
		if(accountType !== ''){
			newAccountType = accountType.toLowerCase();
		}
		let postData = {
			account: {
				financial_institute:bank,
				savings_title:accountName,
				savings_account_number: accountNumber,
				savings_account_routing_number: accountRoutingNumber,
				account_type_token:newAccountType,
				account_deposits_required:'yes',
			}
		};
		if(accountType === 'backup'){
			postData.account.account_type = selectedAccountType || 'CHECKING';
		}

		let config = {};
		if(authToken){
			config.headers = {'Auth-token': authToken}
		}
		let url = '/organizations/'+organization['organization_id']+'/users/'+user['user_id']+'/add-account';
		if(newAccountType === 'backup'){
			url = '/organizations/'+organization['organization_id']+'/users/'+user['user_id']+'/add-backup-account'
		}
		axios.post(url ,postData, config).then(response=>{
			setIsLoading(false);
			successHandler(response);
		}).catch(e=>{
			setIsLoading(false);
			setMessage(getHttpErrorMessage(e));
		});
	};

	return (
		<>

		<Popup closeHandler={closeHandler}>
			<div className={'large-form popup-content form-slide'}>
				<div className={'title'}>
					{accountType !== 'backup' &&
					<h2><img className={'thrive-logo'} src={'/images/thrive-contribution.svg'} alt={'thrive'} />Add Your Emergency Savings Account</h2>
					}
					{accountType === 'backup' &&
						<h2><img className={'thrive-logo'} src={'/images/thrive-contribution.svg'} alt={'thrive'} />Add Your Backup checking Account</h2>
					}
				</div>
				{accountType !== 'backup' &&
					<div style={{padding:'20px', textAlign:'center', marginBottom:'20px'}} className={'body'}>
						After Saving your account information two deposits between $0.01 and $0.20 will be made to the account. Come back to this screen after receiving them to verify the account. Payments will not be made to the account until this is done.
					</div>
				}
				{accountType === 'backup' &&
					<div style={{padding:'20px', textAlign:'center', marginBottom:'20px'}} className={'body'}>
						This alternate checking account will only be used temporarily if we’re unable to send payments directly to your loan servicer. This may occur due to technical issues, connection errors, or updates on the service provider’s platform.
					</div>
				}

				<div className={'form-container no-border'}>

					<div className={'form-inner field-list'}>

						<label>
							Financial Institution Name:
							<input className={(errorFields.includes('bank')?'invalid':'')} value={bank} onChange={(e)=>{setBank(e.target.value)}}/>
						</label>

						<label>
							Account Name:
							<input className={(errorFields.includes('accountName')?'invalid':'')} value={accountName} onChange={(e)=>{setAccountName(e.target.value)}}/>
						</label>
						{accountType === 'backup' &&
							<label>
								Account Type:
								<select value={selectedAccountType} onChange={(e) => {setSelectedAccountType(e.target.value)}}>
									<option value={'CHECKING'} selected={true}>Checking</option>
									<option value={'SAVINGS'}>Savings</option>
								</select>
							</label>
						}
						< label className={'full-row'}>
							Account Number:
							<input className={(errorFields.includes('accountNumber')?'invalid':'')} value={accountNumber} onChange={(e)=>{setAccountNumber(e.target.value)}}/>
						</label>
						<label className={'full-row'}>
							Confirm Account Number:
							<input className={(errorFields.includes('accountNumberConfirmation')?'invalid':'')} value={accountNumberConfirmation} onChange={(e)=>{setAccountNumberConfirmation(e.target.value)}}/>
						</label>
						<label className={'full-row'}>
							Routing Number:
							<NumberFormat
								allowLeadingZeros={true}
								className={(errorFields.includes('accountRoutingNumber') ? 'invalid' : '')}
								placeholder={'#'}
								decimalScale={0}
								thousandSeparator={false}
								value={accountRoutingNumber}
								onValueChange={(values) => {
									const {value} = values;
									setAccountRoutingNumber(value);

								}} />
						</label>
						{accountType === 'backup' &&
						<div>
							<div className={'confirmation'}>
								<div className={'check-holder ' + (errorFields.includes('terms')?'invalid':'')} onClick={() => {
									setAgreed(!agreed)
								}}>
									<span className={'checkbox ' + (agreed ? 'checked ' : ' ')+ (errorFields.includes('terms')?'invalid':'')}/>
									I agree to the <button onClick={(e)=>{e.stopPropagation();setShowTermsPopup(true)}} className={'terms-trigger'}>terms and conditions.</button>
								</div>
							</div>
						</div>
						}
						<div className={'save-row full-row'}>
							<button disabled={isLoading} className={'simple-rounded-button blue'} onClick={(e)=>{saveHandler()}}><span>Save Account</span></button>
							{message && <p className={'popup-form-error'}>{message}</p>}
						</div>
					</div>
				</div>
			</div>
		</Popup>
			{showTermsPopup && <BackupAccountTermsPopup closeHandler={()=>{setShowTermsPopup(false)}} />}
		</>
	)
}
